import React from 'react';
import Styles from './logo.module.scss';

const Logo = () => <img className={Styles.logo} src="https://uiux.s3.amazonaws.com/logo/sg-twilio-lockup.svg" alt="SendGrid Logo" data-role="logo" />;

export default Logo;
